import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function CommunicationIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3609 4C6.58059 4 2.64245 9.85685 4.82333 15.2099L5.75567 17.4984C5.8391 17.7032 5.77811 17.9384 5.6057 18.0769L3.63421 19.6602C3.46878 19.793 3.40522 20.0158 3.47564 20.2159C3.54605 20.4161 3.73512 20.55 3.94729 20.55H11.7676C16.5903 20.55 20.4999 16.6404 20.4999 11.8176C20.4999 7.50008 16.9999 4 12.6823 4H12.3609Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
